import React, { useState, useRef, useEffect } from 'react'

const Search = ({ onChangeSearch, placeholder }) => {
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const thisinput = useRef(null)

  // Debounce el valor de búsqueda
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
    }, 300) // 300ms de debounce

    return () => {
      clearTimeout(handler)
    }
  }, [search])

  // Ejecutar la búsqueda cuando el valor debounced cambie
  useEffect(() => {
    onChangeSearch(debouncedSearch)
  }, [debouncedSearch]) // Removemos onChangeSearch de las dependencias

  /*
    useEffect(() => {
        thisinput.current.focus()
    })*/

  return (
    <div className='search' style={{ minWidth: "120px"}}>
      <div className='searchbar__wrap'>
        <h4 className='filter__title'>Buscador</h4>
        <input
          className='btn-filter search placeholder-text'
          type='text'
          ref={thisinput}
          value={search}
          onChange={(e) => {
            const { value } = e.target
            setSearch(value)
          }}
          placeholder={placeholder}
        />
      </div>
    </div>
  )
}
export default Search
